export default function () {
  const ta = document.createElement('script')
  ta.type = 'text/javascript'
  ta.async = true
  ta.charset = 'utf-8'
  ta.src = '//b-code.liadm.com/a-04c5.min.js'

  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(ta, s)
}
